
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("axg8K", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return (parcelRequire("dKFLo")).Input; });
$parcel$export(module.exports, "InputIcon", function () { return (parcelRequire("fuUhM")).InputIcon; });
$parcel$export(module.exports, "Login", function () { return (parcelRequire("9CUtk")).Login; });
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("fYPhW")).LogoButton; });
$parcel$export(module.exports, "ProviderLogo", function () { return (parcelRequire("fYPhW")).ProviderLogo; });
$parcel$export(module.exports, "Separator", function () { return (parcelRequire("4kWD7")).Separator; });
$parcel$export(module.exports, "Social", function () { return (parcelRequire("aZTjH")).Social; });
$parcel$export(module.exports, "Submit", function () { return (parcelRequire("g9fB0")).Submit; });
$parcel$export(module.exports, "useAccountCreationContext", function () { return (parcelRequire("a3QsU")).useAccountCreationContext; });

$parcel$export(module.exports, "default", function () { return $1e3a62a4f38e1eb2$export$2e2bcd8739ae039; });

var $gX3Qo = parcelRequire("gX3Qo");
parcelRequire("5Hsvq");
parcelRequire("gZnXH");
var $1e3a62a4f38e1eb2$export$2e2bcd8739ae039 = (0, $gX3Qo.AccountCreation);

});
parcelRegister("gX3Qo", function(module, exports) {

$parcel$export(module.exports, "AccountCreation", function () { return $f814c25b4c9544dc$export$b841b541bc741e79; });

var $7Knp0 = parcelRequire("7Knp0");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("5Hsvq");
var $2bT0L = parcelRequire("2bT0L");
parcelRequire("gZnXH");
var $a3QsU = parcelRequire("a3QsU");
const $f814c25b4c9544dc$export$b841b541bc741e79 = (_param)=>/*#__PURE__*/ {
    var { identityCobranding: identityCobranding, templateId: templateId } = _param, props = (0, $akGnX._)(_param, [
        "identityCobranding",
        "templateId"
    ]);
    return (0, $loA2J.jsx)((0, $a3QsU.AccountCreationContextProvider), {
        identityCobranding: identityCobranding,
        templateId: templateId,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2bT0L.Content), (0, $7Knp0._)({}, props))
    });
};

});
parcelRegister("5Hsvq", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return (parcelRequire("2bT0L")).Content; });
$parcel$export(module.exports, "Input", function () { return (parcelRequire("dKFLo")).Input; });
$parcel$export(module.exports, "InputIcon", function () { return (parcelRequire("fuUhM")).InputIcon; });
$parcel$export(module.exports, "Login", function () { return (parcelRequire("9CUtk")).Login; });
$parcel$export(module.exports, "Separator", function () { return (parcelRequire("4kWD7")).Separator; });
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("fYPhW")).LogoButton; });
$parcel$export(module.exports, "ProviderLogo", function () { return (parcelRequire("fYPhW")).ProviderLogo; });
$parcel$export(module.exports, "Social", function () { return (parcelRequire("aZTjH")).Social; });
$parcel$export(module.exports, "Submit", function () { return (parcelRequire("g9fB0")).Submit; });
parcelRequire("a7tWk");
parcelRequire("iBEnu");
parcelRequire("bJf1a");
parcelRequire("7WH0a");
parcelRequire("fA47Y");
parcelRequire("4kWD7");
parcelRequire("80xo3");
parcelRequire("cGC0Q");

});
parcelRegister("a7tWk", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return (parcelRequire("2bT0L")).Content; });
parcelRequire("2bT0L");

});
parcelRegister("2bT0L", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $23ac6fbd88a3dc80$export$7c6e2c02157bb7d2; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $6oKbD = parcelRequire("6oKbD");
parcelRequire("gZnXH");
var $a3QsU = parcelRequire("a3QsU");
parcelRequire("iBEnu");
var $3k7s7 = parcelRequire("3k7s7");
parcelRequire("bJf1a");
var $dKFLo = parcelRequire("dKFLo");
parcelRequire("fA47Y");
var $9CUtk = parcelRequire("9CUtk");

var $4kWD7 = parcelRequire("4kWD7");
parcelRequire("80xo3");
var $aZTjH = parcelRequire("aZTjH");
parcelRequire("cGC0Q");
var $g9fB0 = parcelRequire("g9fB0");
const $23ac6fbd88a3dc80$export$7c6e2c02157bb7d2 = ({ Submit: Submit = /*#__PURE__*/ (0, $loA2J.jsx)((0, $g9fB0.Submit), {}), Input: Input = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dKFLo.Input), {}), Social: Social = /*#__PURE__*/ (0, $loA2J.jsx)((0, $aZTjH.Social), {}), Separator: Separator = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4kWD7.Separator), {}), Error: Error = /*#__PURE__*/ (0, $loA2J.jsx)((0, $3k7s7.Error), {}), Login: Login = /*#__PURE__*/ (0, $loA2J.jsx)((0, $9CUtk.Login), {}) })=>{
    const { onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA } = (0, $a3QsU.useAccountCreationContext)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
                onSubmit: onSubmitWithReCAPTCHA,
                isDisabled: false,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                        autoComplete: "off",
                        "data-testid": "account-creation",
                        children: [
                            Input,
                            Submit
                        ]
                    }))
            }),
            Error,
            Separator,
            Social,
            Login
        ]
    });
};

});
parcelRegister("gZnXH", function(module, exports) {
$parcel$export(module.exports, "AccountCreationContextProvider", function () { return (parcelRequire("a3QsU")).AccountCreationContextProvider; });
$parcel$export(module.exports, "useAccountCreationContext", function () { return (parcelRequire("a3QsU")).useAccountCreationContext; });
parcelRequire("a3QsU");

});
parcelRegister("a3QsU", function(module, exports) {

$parcel$export(module.exports, "useAccountCreationContext", function () { return $48ea53e91458f1c9$export$30b295205cfae694; });
$parcel$export(module.exports, "AccountCreationContextProvider", function () { return $48ea53e91458f1c9$export$b0a1b3550379fc78; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $eZAyW = parcelRequire("eZAyW");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $f0Hih = parcelRequire("f0Hih");

var $iMdoL = parcelRequire("iMdoL");

var $gkhN4 = parcelRequire("gkhN4");

var $9iWJ8 = parcelRequire("9iWJ8");

var $lrVTP = parcelRequire("lrVTP");

var $dWbel = parcelRequire("dWbel");
const { IDENTITY_USER_SIGNUP_API: $48ea53e91458f1c9$var$IDENTITY_USER_SIGNUP_API } = (0, $jgJpJ.UfoCustomTimingKey);
const $48ea53e91458f1c9$export$52bc2238e0ff8657 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $48ea53e91458f1c9$export$30b295205cfae694 = ()=>{
    const context = (0, $iSvIT.useContext)($48ea53e91458f1c9$export$52bc2238e0ff8657);
    if (!context) throw new Error("useAccountCreationContext must be used within a AccountCreationContextProvider");
    return context;
};
const $48ea53e91458f1c9$export$b0a1b3550379fc78 = ({ identityCobranding: identityCobranding = "wac", templateId: templateId, children: children })=>{
    const location = (0, $lrVTP.useLocation)();
    const isEmbedded = !location.pathname.endsWith("/try/cloud/signup");
    const { product: product, edition: edition } = (0, $iMdoL.useUserContext)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const [isEmailValid, setIsEmailValid] = (0, $iSvIT.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $iSvIT.useState)(false);
    const [isReadyForInvalid, setIsReadyForInvalid] = (0, $iSvIT.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $iSvIT.useState)(false);
    const [formError, setFormError] = (0, $iSvIT.useState)(false);
    const [_email, setEmail] = (0, $iSvIT.useState)("");
    const [typeAheadEmail, setTypeAheadEmail] = (0, $iSvIT.useState)("");
    const [onSubmitProps, setOnSubmitProps] = (0, $iSvIT.useState)(undefined);
    const [recaptchaFailedToLoad, setRecaptchaFailedToLoad] = (0, $iSvIT.useState)(false);
    const [recaptchaRetryTimeRemainingSecond, setRecaptchaRetryTimeRemainingSecond] = (0, $iSvIT.useState)(60);
    const [tryIntentAnalyticsEventHasFired, setTryIntentAnalyticsEventHasFired] = (0, $iSvIT.useState)(false);
    const localePath = (0, $jgJpJ.getLocalePath)(intl.locale);
    const signupClient = (0, $gkhN4.useBxpWebStargateClient)();
    const { executeRecaptcha: executeRecaptcha } = (0, $eZAyW.useGoogleReCaptcha)();
    const continueParam = (0, $jgJpJ.getContinueParam)(location);
    // identity interstitial redirect experiments
    const redirectExperiments = [
        (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).cfind4802ConfluenceAccountCreationRedirect),
        (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).cfind4802JiraAccountCreationRedirect)
    ];
    const dataFoundationsActionSubjectId = !!isEmbedded ? "embedded" : "standalone";
    // default experiment params
    if (identityCobranding === "wac") {
        if ((product === null || product === void 0 ? void 0 : product.name) === "confluence") identityCobranding = "wac--otp-confluence";
        else if ((product === null || product === void 0 ? void 0 : product.name) === "jira") identityCobranding = "wac--otp-jira";
        else if ((product === null || product === void 0 ? void 0 : product.name) === "loom") identityCobranding = "wac--loom";
        else if ((product === null || product === void 0 ? void 0 : product.name) === "jira-product-discovery") identityCobranding = "wac--jpd";
        else if ((product === null || product === void 0 ? void 0 : product.name) === "jira-servicedesk") identityCobranding = "wac--jsm";
    }
    const redirectTo = continueParam ? continueParam : (0, $jgJpJ.getNameYourSiteRedirectUrl)({
        bundle: product === null || product === void 0 ? void 0 : product.bundle,
        edition: edition,
        localePath: localePath,
        templateId: templateId,
        application: identityCobranding
    });
    (0, $iSvIT.useEffect)(()=>{
        if (!analyticsClient) return;
        (0, $jgJpJ.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            productKey: product === null || product === void 0 ? void 0 : product.key,
            edition: edition
        });
        (0, $jgJpJ.ufoEventSignupFormLoad).success({
            customData: {
                webPlatform: "bxp-ui",
                reactComponent: "DefaultSignupForm",
                isLoggedIn: false
            }
        });
        (0, $jgJpJ.trackSignFormLoad)(createAnalyticsEvent);
        (0, $jgJpJ.trackTimeToFormReady)(createAnalyticsEvent, performance.now());
    }, [
        createAnalyticsEvent,
        edition,
        product === null || product === void 0 ? void 0 : product.key,
        dataFoundationsActionSubjectId,
        analyticsClient
    ]);
    const onSubmitWithReCAPTCHA = (0, $iSvIT.useCallback)(async ({ email: email })=>{
        setIsReadyForInvalid(true);
        if (!email || !isEmailValid) {
            (0, $jgJpJ.trackInvalidEmail)(createAnalyticsEvent);
            return;
        }
        // check identity interstitial redirect experiments for enrollment
        if (redirectExperiments.some(({ type: type })=>type === "enrolled")) {
            redirectExperiments.forEach((experiment)=>{
                if (experiment.type === "enrolled") experiment.fireExposure();
            });
            const shouldRedirectToInterstitial = redirectExperiments.some((experiment)=>experiment.type === "enrolled" && experiment.value);
            if (shouldRedirectToInterstitial) {
                const url = (0, $jgJpJ.getIdentityInterstitialUrl)(email, redirectTo, identityCobranding);
                window.location.assign(url);
                return;
            }
        }
        setOnSubmitProps({
            email: email
        });
        setIsSubmitting(true);
        if (!executeRecaptcha && recaptchaRetryTimeRemainingSecond > 0) {
            // set trigger that will wait for Recaptcha retry logic
            setFormError(true);
            setIsSubmitting(false);
            setRecaptchaFailedToLoad(true);
            return;
        }
        setRecaptchaFailedToLoad(false);
        // Start UFO to begin duration measurements for account creation
        (0, $jgJpJ.ufoEventAccountCreation).start({
            productKey: product === null || product === void 0 ? void 0 : product.key,
            webPlatform: "bxp-ui"
        });
        const gRecaptchaResponse = await (0, $jgJpJ.getRecaptcha)(email, executeRecaptcha);
        (0, $jgJpJ.ufoEventAccountCreation).setCustomData({
            gRecaptchaResponse: gRecaptchaResponse !== null && gRecaptchaResponse !== void 0 ? gRecaptchaResponse : "none",
            executeRecaptchaExists: Boolean(executeRecaptcha),
            reactComponent: "AccountCreationContextProvider"
        });
        // Handle missing reCAPTCHA response
        if (!gRecaptchaResponse) {
            (0, $jgJpJ.trackRecaptchaFailure)(createAnalyticsEvent, "account-creation");
            const invalidRecaptchaError = new Error("Missing reCAPTCHA token");
            (0, $jgJpJ.ufoEventAccountCreation).failure({
                customData: {
                    reactComponent: "AccountCreationContextProvider"
                },
                error: invalidRecaptchaError
            });
            throw invalidRecaptchaError;
        }
        (0, $jgJpJ.trackFormSubmit)(createAnalyticsEvent, product === null || product === void 0 ? void 0 : product.key, edition);
        const existingUserRedirectUrl = await (0, $jgJpJ.getMethodsAvailableRedirection)({
            email: email,
            application: identityCobranding,
            signupClient: signupClient,
            createAnalyticsEvent: createAnalyticsEvent,
            successRedirect: redirectTo
        }).catch((error)=>{
            setFormError(true);
            setIsSubmitting(false);
            (0, $jgJpJ.trackSignupFailure)(createAnalyticsEvent);
            throw new Error(error);
        });
        if (existingUserRedirectUrl) {
            window.location.assign(existingUserRedirectUrl.replace("/initiate/password", ""));
            return;
        }
        const newUserRedirectTo = redirectTo + `&n2n=true`;
        (0, $jgJpJ.ufoEventAccountCreation).startSubstep($48ea53e91458f1c9$var$IDENTITY_USER_SIGNUP_API);
        await signupClient.userSignup({
            application: identityCobranding,
            displayName: "",
            email: email,
            gRecaptchaResponse: gRecaptchaResponse,
            locale: intl.locale,
            products: [
                {
                    productKey: (product === null || product === void 0 ? void 0 : product.key) || (0, $jgJpJ.ProductKey).JIRA_SOFTWARE,
                    edition: edition || "free"
                }
            ],
            redirectTo: newUserRedirectTo
        }).then(({ otpRedirect: otpRedirect })=>{
            (0, $jgJpJ.ufoEventAccountCreation).endSubstep($48ea53e91458f1c9$var$IDENTITY_USER_SIGNUP_API);
            if (!otpRedirect) throw new Error("No OTP redirect");
            // Reliability SLO "good event" metric emitted for submit account creation
            (0, $jgJpJ.ufoEventAccountCreation).success({
                customData: {
                    reactComponent: "AccountCreationContextProvider"
                }
            });
            (0, $jgJpJ.trackSubmitSuccess)(createAnalyticsEvent);
            window.location.assign(otpRedirect);
        }).catch((error)=>{
            // Reliability SLO "bad event" metric emitted for submit account creation
            (0, $jgJpJ.ufoEventAccountCreation).endSubstep($48ea53e91458f1c9$var$IDENTITY_USER_SIGNUP_API);
            (0, $jgJpJ.ufoEventAccountCreation).failure({
                customData: {
                    reactComponent: "AccountCreationContextProvider"
                },
                error: error
            });
            setEmail(email);
            setFormError(true);
            setHasSubmitted(true);
            setIsSubmitting(false);
            (0, $jgJpJ.trackSignupFailure)(createAnalyticsEvent);
            throw new Error(error);
        });
    }, [
        createAnalyticsEvent,
        edition,
        executeRecaptcha,
        identityCobranding,
        intl.locale,
        isEmailValid,
        product,
        recaptchaRetryTimeRemainingSecond,
        redirectTo,
        signupClient
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (recaptchaFailedToLoad && recaptchaRetryTimeRemainingSecond <= 0) (0, $jgJpJ.ufoEventAccountCreation).failure({
            customData: {
                reactComponent: "AccountCreationContextProvider",
                recaptchaRetryTimeRemainingSecond: 0
            },
            error: new Error("Recaptcha retry failed")
        });
        if (onSubmitProps && recaptchaFailedToLoad && executeRecaptcha) onSubmitWithReCAPTCHA(onSubmitProps).then(()=>{
            (0, $jgJpJ.ufoEventAccountCreation).success({
                customData: {
                    reactComponent: "AccountCreationContextProvider",
                    analyticsEvent: "succeeded",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                }
            });
        }).catch((error)=>{
            setFormError(true);
            (0, $jgJpJ.ufoEventAccountCreation).failure({
                customData: {
                    reactComponent: "AccountCreationContextProvider",
                    analyticsEvent: "errored",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                },
                error: error
            });
            return;
        }).finally(()=>{
            setIsSubmitting(false);
        });
    }, [
        executeRecaptcha,
        recaptchaFailedToLoad,
        onSubmitProps,
        onSubmitWithReCAPTCHA,
        recaptchaRetryTimeRemainingSecond
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!recaptchaFailedToLoad) return;
        if (recaptchaRetryTimeRemainingSecond <= 0) return;
        const intervalId = setInterval(()=>{
            setRecaptchaRetryTimeRemainingSecond(recaptchaRetryTimeRemainingSecond - 1);
        }, 1000);
        return ()=>clearInterval(intervalId);
    }, [
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond
    ]);
    const onClickSocialButton = (provider)=>{
        (0, $jgJpJ.trackContinueWithSocialSignups)(createAnalyticsEvent, provider, product === null || product === void 0 ? void 0 : product.key, edition);
        const socialRedirectUrl = (0, $jgJpJ.getSocialButtonUrl)({
            redirectTo: redirectTo,
            identityCobranding: identityCobranding,
            provider: provider
        });
        window.location.assign(socialRedirectUrl);
    };
    const onClickSubmitButton = ()=>(0, $jgJpJ.trackSubmitButtonClick)(createAnalyticsEvent);
    return /*#__PURE__*/ (0, $loA2J.jsx)($48ea53e91458f1c9$export$52bc2238e0ff8657.Provider, {
        value: {
            dataFoundationsActionSubjectId: dataFoundationsActionSubjectId,
            edition: edition,
            formError: formError,
            hasSubmitted: hasSubmitted,
            identityCobranding: identityCobranding,
            isReadyForInvalid: isReadyForInvalid,
            isSubmitting: isSubmitting,
            onClickSocialButton: onClickSocialButton,
            onClickSubmitButton: onClickSubmitButton,
            onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA,
            product: product,
            redirectTo: redirectTo,
            setIsEmailValid: setIsEmailValid,
            setIsReadyForInvalid: setIsReadyForInvalid,
            setTypeAheadEmail: setTypeAheadEmail,
            typeAheadEmail: typeAheadEmail,
            tryIntentAnalyticsEventHasFired: tryIntentAnalyticsEventHasFired
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $f0Hih.default), {
            edition: edition,
            intentType: "form",
            productKey: product === null || product === void 0 ? void 0 : product.key,
            onAnalyticsEventFired: ()=>!tryIntentAnalyticsEventHasFired && setTryIntentAnalyticsEventHasFired(true),
            children: children
        })
    });
};

});


parcelRegister("iBEnu", function(module, exports) {
$parcel$export(module.exports, "Error", function () { return (parcelRequire("3k7s7")).Error; });
parcelRequire("3k7s7");

});
parcelRegister("3k7s7", function(module, exports) {

$parcel$export(module.exports, "Error", function () { return $665309e9abc4fc8b$export$edf27be85e5f6da0; });
/* error.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");
parcelRequire("gZnXH");
var $a3QsU = parcelRequire("a3QsU");
const $665309e9abc4fc8b$export$edf27be85e5f6da0 = ({ errorText: errorText })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $f6qj2.default)();
    const { formError: formError } = (0, $a3QsU.useAccountCreationContext)();
    if (!formError) return null;
    if (errorText === undefined) errorText = locale === "en" ? formatMessage({
        id: "AccountCreation.userSignupError",
        defaultMessage: `It's taking longer than expected to get you started. Please refresh and try again or <contactUsLink>contact us</contactUsLink>.`
    }, {
        contactUsLink: $665309e9abc4fc8b$var$contactUsLink
    }) : formatMessage({
        id: "BxpUiSignup.SignupForm.formError",
        defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>."
    }, {
        contactUsLink: $665309e9abc4fc8b$var$contactUsLink
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        role: "alert",
        className: (0, $esG4f.default)([
            "_syaz1cjc _19pk1j6v _2hwxidpf _otyr1j6v _18u0idpf _3fcw150s"
        ]),
        children: errorText
    });
};
const $665309e9abc4fc8b$var$contactUsLink = (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: "/company/contact",
        className: "linkText"
    });
const $665309e9abc4fc8b$var$errorCss = null;

});


parcelRegister("bJf1a", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return (parcelRequire("dKFLo")).Input; });
parcelRequire("dKFLo");

});
parcelRegister("dKFLo", function(module, exports) {

$parcel$export(module.exports, "Input", function () { return $4d62c2fdd6741ebb$export$f5b8910cec6cf069; });
/* input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $26kkA = parcelRequire("26kkA");

var $7OGW4 = parcelRequire("7OGW4");

var $jgJpJ = parcelRequire("jgJpJ");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("gZnXH");
var $a3QsU = parcelRequire("a3QsU");
parcelRequire("7WH0a");
var $fuUhM = parcelRequire("fuUhM");
const $4d62c2fdd6741ebb$var$HELP_TEXT_ID = "account_creation_email_help_text";
const $4d62c2fdd6741ebb$export$f5b8910cec6cf069 = ({ helpText: helpText, errorMessageText: errorMessageText, labelText: labelText, placeholderText: placeholderText })=>{
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail, typeAheadEmail: typeAheadEmail } = (0, $a3QsU.useAccountCreationContext)();
    const [email, setEmail] = (0, $iSvIT.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $iSvIT.useState)();
    const intl = (0, $f6qj2.default)();
    if (helpText === undefined) helpText = intl.formatMessage({
        id: "signupForm.accountCreation.helperText",
        defaultMessage: "Using a work email helps find teammates and boost collaboration."
    });
    if (errorMessageText === undefined) errorMessageText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.invalidEmail",
        defaultMessage: "Please enter a valid email address."
    });
    if (labelText === undefined) labelText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.workEmail",
        defaultMessage: "Work email"
    });
    if (placeholderText === undefined) placeholderText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.emailPlaceholder",
        defaultMessage: "you@company.com"
    });
    (0, $iSvIT.useEffect)(()=>{
        const isValid = (0, $jgJpJ.emailIsValid)(email); // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_6rth7vkz _1rwq121t _1heubzd7 _125x1syg _62vcmccc _1d6jidpf _1t2q1kw7 _17rnbzd7 _1q9pbfng _d78pglyw"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
            "aria-required": true,
            isRequired: true,
            label: labelText,
            name: "email",
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_zbay183y",
                        isValid === true && "_1lo6qn1y",
                        isValid === false && "_1lo61wfy"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OGW4.default), (0, $6iHNw._)((0, $7Knp0._)({}, fieldProps), {
                            autoComplete: "email",
                            "aria-describedby": $4d62c2fdd6741ebb$var$HELP_TEXT_ID,
                            elemAfterInput: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fuUhM.InputIcon), {
                                valid: isValid
                            }),
                            onBlur: ()=>setIsReadyForInvalid(true),
                            onChange: (e)=>{
                                setEmail(e.target.value);
                                setTypeAheadEmail(e.target.value);
                                fieldProps.onChange(e);
                            },
                            placeholder: placeholderText,
                            testId: "email_field",
                            type: "email",
                            value: email
                        })),
                        isValid === false ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            id: $4d62c2fdd6741ebb$var$HELP_TEXT_ID,
                            role: "alert",
                            className: (0, $esG4f.default)([
                                "_syaz1tmw _1wybepq8 _vwz4bs82 _1pfhi2wt"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                            },
                            children: errorMessageText
                        }) : helpText ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            id: $4d62c2fdd6741ebb$var$HELP_TEXT_ID,
                            className: (0, $esG4f.default)([
                                "_syaz1io3 _1wybepq8 _vwz4bs82 _1pfhi2wt"
                            ]),
                            style: {
                                "--_138lqrp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark500")),
                                "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                            },
                            children: helpText
                        }) : null
                    ]
                })
        })
    });
};
const $4d62c2fdd6741ebb$var$errorMessageCss = null;
const $4d62c2fdd6741ebb$var$helpTextCss = null;
const $4d62c2fdd6741ebb$var$fieldCss = null;
const $4d62c2fdd6741ebb$var$inputCss = null;
const $4d62c2fdd6741ebb$var$inputInvalidCss = null;
const $4d62c2fdd6741ebb$var$inputValidCss = null;

});
parcelRegister("7WH0a", function(module, exports) {
$parcel$export(module.exports, "InputIcon", function () { return (parcelRequire("fuUhM")).InputIcon; });
parcelRequire("fuUhM");

});
parcelRegister("fuUhM", function(module, exports) {

$parcel$export(module.exports, "InputIcon", function () { return $7d9f88f07b8cb2ac$export$f8fea9f50a4bfae6; });
/* input-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $bDTBs = parcelRequire("bDTBs");

var $1EpFI = parcelRequire("1EpFI");

var $jgJpJ = parcelRequire("jgJpJ");

var $5ohHq = parcelRequire("5ohHq");
const $7d9f88f07b8cb2ac$export$f8fea9f50a4bfae6 = ({ valid: valid })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const validMessage = formatMessage({
        id: "signupForm.accountCreation.validEmailIcon",
        defaultMessage: "Success"
    });
    const invalidMessage = formatMessage({
        id: "signupForm.accountCreation.invalidEmailIcon",
        defaultMessage: "Warning"
    });
    if (valid === undefined) return null;
    return valid ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _lswucd5j _1wyb1syg _y4tiftgi _syaz1ua5"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bDTBs))), {
            label: validMessage,
            size: "medium"
        })
    }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _lswucd5j _1wyb1syg _y4tiftgi _syaz1bqt"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1EpFI))), {
            label: invalidMessage,
            size: "medium"
        })
    });
};
const $7d9f88f07b8cb2ac$var$iconWrapperStyle = {
    alignItems: "center",
    display: "flex",
    fill: (0, $5ohHq.wacToken)("color.neutral.light0"),
    fontSize: (0, $jgJpJ.fontSize).md,
    paddingInlineEnd: 8
};
const $7d9f88f07b8cb2ac$var$iconValidCss = null;
const $7d9f88f07b8cb2ac$var$iconInvalidCss = null;

});




parcelRegister("fA47Y", function(module, exports) {
$parcel$export(module.exports, "Login", function () { return (parcelRequire("9CUtk")).Login; });
parcelRequire("9CUtk");

});
parcelRegister("9CUtk", function(module, exports) {

$parcel$export(module.exports, "Login", function () { return $7eb7007ec0fb9816$export$21a94553ffa41578; });
/* login.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $jgJpJ = parcelRequire("jgJpJ");

var $1UUq1 = parcelRequire("1UUq1");

var $lrVTP = parcelRequire("lrVTP");
parcelRequire("gZnXH");
var $a3QsU = parcelRequire("a3QsU");
const $7eb7007ec0fb9816$export$21a94553ffa41578 = ({ loginText: loginText })=>{
    const intl = (0, $f6qj2.default)();
    const location = (0, $lrVTP.useLocation)();
    const { product: product } = (0, $a3QsU.useAccountCreationContext)();
    if (loginText === undefined) loginText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.existingProduct",
        defaultMessage: "Already have {product}? <logInLink>Log in</logInLink>"
    }, {
        product: product === null || product === void 0 ? void 0 : product.description,
        logInLink: (text)=>$7eb7007ec0fb9816$var$logInLink(text, location)
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        className: (0, $esG4f.default)([
            "_1wyb8oy7 _19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1h6o"
        ]),
        style: {
            "--_djwknj": (0, $43MIc.default)((0, $jgJpJ.fontSize).sm)
        },
        children: loginText
    });
};
const $7eb7007ec0fb9816$var$logInLink = (text, location)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: (0, $jgJpJ.getLoginUrl)(location)
    });
const $7eb7007ec0fb9816$var$existingProductCss = null;

});


parcelRegister("80xo3", function(module, exports) {
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("fYPhW")).LogoButton; });
$parcel$export(module.exports, "ProviderLogo", function () { return (parcelRequire("fYPhW")).ProviderLogo; });
$parcel$export(module.exports, "Social", function () { return (parcelRequire("aZTjH")).Social; });
parcelRequire("fYPhW");
parcelRequire("aZTjH");

});
parcelRegister("aZTjH", function(module, exports) {

$parcel$export(module.exports, "Social", function () { return $a38670e4fd5fec74$export$9a0fadb2797ac9a5; });
/* social.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("gZnXH");
var $a3QsU = parcelRequire("a3QsU");

var $fYPhW = parcelRequire("fYPhW");
const $a38670e4fd5fec74$export$9a0fadb2797ac9a5 = ({ providers: providers })=>{
    const intl = (0, $f6qj2.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $a3QsU.useAccountCreationContext)();
    if (providers === undefined) providers = {
        google: "Google",
        microsoft: "Microsoft",
        apple: "Apple",
        slack: "Slack"
    };
    const buttons = Object.entries(providers); // when there are 3 buttons, we display in a single row and visually hide the text labels
    const rowStyle = buttons.length === 3 && (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).signupAccountCreationSocialRowStyle); /* eslint-disable jsx-a11y/no-redundant-roles */ 
    /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
        role: "list",
        className: (0, $esG4f.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            buttons.length > 1 && !rowStyle && "_1e0c11p5 _zulp7vkz _yv0efsjm",
            rowStyle && "_1e0c11p5 _zulp7vkz _wij21bp4"
        ]),
        children: buttons.map(([provider, label])=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $fYPhW.LogoButton), {
                    "aria-label": intl.formatMessage({
                        id: "social.label.signup",
                        defaultMessage: "sign up with {provider}"
                    }, {
                        provider: label
                    }),
                    onClick: ()=>onClickSocialButton(provider),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $fYPhW.ProviderLogo), {
                            logo: provider
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                rowStyle && "_kqswstnw _1e021cib _152t1wug _1bsbt94y _4t3it94y _1reo15vq _18m915vq _ogtohxbz _o5721q9c"
                            ]),
                            children: label
                        })
                    ]
                })
            }, provider))
    });
};
const $a38670e4fd5fec74$var$buttonGridCss = null;
const $a38670e4fd5fec74$var$buttonListCss = null;
const $a38670e4fd5fec74$var$buttonRowCss = null;
const $a38670e4fd5fec74$var$srOnlyCss = null;

});


parcelRegister("cGC0Q", function(module, exports) {
$parcel$export(module.exports, "Submit", function () { return (parcelRequire("g9fB0")).Submit; });
parcelRequire("g9fB0");

});
parcelRegister("g9fB0", function(module, exports) {

$parcel$export(module.exports, "Submit", function () { return $2e88de5ad09fd3a8$export$2c4cf1f7b42ef78c; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $91nJf = parcelRequire("91nJf");
parcelRequire("gZnXH");
var $a3QsU = parcelRequire("a3QsU");
const $2e88de5ad09fd3a8$export$2c4cf1f7b42ef78c = ({ buttonText: buttonText })=>{
    const intl = (0, $f6qj2.default)();
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $a3QsU.useAccountCreationContext)();
    if (buttonText === undefined) buttonText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.submit",
        defaultMessage: "Sign up"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted && !formError,
        isFullWidth: true,
        isLoading: isSubmitting || hasSubmitted && !formError,
        onClick: onClickSubmitButton,
        children: buttonText
    });
};

});








//# sourceMappingURL=confirmation-page.4dd88662.js.map
